import { Fragment, MouseEvent } from 'react';

import { ActivelyHiringBadge } from 'components/ActivelyHiringBadge/ActivelyHiringBadge';
import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import { Link } from 'components/Link';
import { H1 } from 'components/Text/H1';
import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { ListingTypeLabel } from 'modules/listing/components/ListingTypeLabel/ListingTypeLabel';
import { getCityStateString } from 'utils/address/getCityStateString';
import { formatToHumanReadableUrl } from 'utils/string/formatToHumanReadableLink/formatToHumanReadableUrl';

import { ViewOrgPageActionButtons } from './ViewOrgPageActionButtons';

type Props = {
  org: ApiOrg;
  isPreview: boolean;
  onClickOpportunities: (
    e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    analyticsProperties?: Record<string, unknown>,
  ) => void;
};

export function ViewOrgPageHeader({
  org,
  isPreview,
  onClickOpportunities,
}: Props) {
  return (
    <>
      <Box mb="24px">
        <ListingTypeLabel listingType="ORG" orgType={org.orgType} />
        {org.hiring && (
          <Box mt="20px">
            <ActivelyHiringBadge />
          </Box>
        )}
      </Box>

      <H1
        styleAs="h2"
        color="mediumContentGrey"
        data-qa-id="listing-name"
        lineHeight={1}
        mb="24px"
      >
        {org.name}
      </H1>
      <Box lineHeight={1} mb={['12px', null, null, '24px']}>
        {org.address && <>{getCityStateString(org.address)}</>}

        {org.links.length > 0 &&
          org.links.map((link) => (
            <Fragment key={link}>
              {' | '}
              <Link href={link} target="_blank" rel="noopener noreferrer">
                {formatToHumanReadableUrl(link)}
              </Link>
            </Fragment>
          ))}
      </Box>
      <Hide xs sm md>
        <div>
          <ViewOrgPageActionButtons
            org={org}
            isPreview={isPreview}
            onClickOpportunities={onClickOpportunities}
            mobile={false}
          />
        </div>
      </Hide>
    </>
  );
}
